"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var removeExtraLeadingZero = {
  test: function test(source) {
    return /^-?0\d+/.test(source);
  },
  processNumber: function processNumber(_ref) {
    var source = _ref.source,
      caret = _ref.caret;
    var _ref2 = caret,
      start = _ref2.start,
      end = _ref2.end;
    var expression = /^(-?)(0+)(\d+.*)/;
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    var _ref3 = source.match(expression),
      _ref4 = (0, _slicedToArray2["default"])(_ref3, 4),
      match = _ref4[0],
      negativeSign = _ref4[1],
      extraLeadingZeros = _ref4[2],
      rest = _ref4[3];
    return {
      source: "".concat(negativeSign).concat(rest),
      caret: {
        start: start - extraLeadingZeros.length,
        end: end - extraLeadingZeros.length
      }
    };
  }
};
var _default = exports["default"] = removeExtraLeadingZero;